<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/checkList')">考核列表</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>考核情况</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns122">
        <li>
          <el-button
            @click="backCheckList"
            type="primary"
          >返回</el-button>
        </li>
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label="代理信息">
            <el-input v-model="filters.keyword" />
          </el-form-item>

          <el-form-item
            v-if="checkInfo.infoType == 2"
            label="年份"
            prop="currentYear"
          >
            <el-select
              v-model="filters.currentYear"
              placeholder="请选择"
            >
              <el-option
                label="2019"
                value="2019"
              ></el-option>
              <el-option
                label="2020"
                value="2020"
              ></el-option>
              <el-option
                label="2021"
                value="2021"
              ></el-option>
              <el-option
                label="2022"
                value="2022"
              ></el-option>
              <el-option
                label="2023"
                value="2023"
              ></el-option>
              <el-option
                label="2024"
                value="2024"
              ></el-option>

            </el-select>
          </el-form-item>

          <el-form-item
            v-if="checkInfo.infoType == 1"
            label="月度考核月份"
            prop="inMonth"
          >
            <el-date-picker
              v-model="filters.inMonth"
              type="month"
              placeholder="选择月"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item
            v-if="checkInfo.infoType == 2"
            label="是否当季升级"
            prop="isCur"
          >
            <el-select
              clearable
              v-if="checkInfo.infoType == 2"
              v-model="filters.isCur"
              placeholder=""
            >
              <el-option
                label="是"
                value="1"
              ></el-option>
              <el-option
                label="不是"
                value="2"
              ></el-option>

            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>
            <el-button
              style="margin-left:10px"
              @click="excelOut"
              type="danger"
            >导出</el-button>
          </el-form-item>

          <span v-show="checkInfo.roleType == 3 && checkInfo.infoType == 2">邀请省代：{{proB}}元，邀请CEO：{{ceoB}}元</span>
        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="username"
            label="代理姓名"
          >
          </el-table-column>
          <el-table-column
            label="代理手机号"
            prop="telephone"
          >
          </el-table-column>

          <el-table-column
            prop="group_type"
            label="团队"
          >
          <template slot-scope="scope">
            <span v-if="scope.row.group_type == 1">陈</span>
            <span v-else>孙</span>
          </template>
          </el-table-column>

          <el-table-column
            label="代理级别"
            :formatter="formatterRoleType"
            prop="role_type"
          >
          </el-table-column>

          <el-table-column label="头像">
            <template slot-scope="scope">
              <el-popover
                placement="top"
                title=""
                trigger="hover"
              >
                <img
                  style="max-height: 200px;max-width: 200px"
                  :src="scope.row.user_head"
                />
                <img
                  slot="reference"
                  :src="scope.row.user_head"
                  :alt="scope.row.user_head"
                  style="max-height: 50px;max-width: 130px"
                >
              </el-popover>
            </template>
          </el-table-column>

          <el-table-column
            label="完成金额"
            prop="get_money"
          >
          <template slot-scope="scope">
            <span v-if="scope.row.get_money < scope.row.targetMoney" style="color:red">{{scope.row.get_money}}</span>
            <span v-else>{{scope.row.get_money}}</span>
          </template>
          </el-table-column>

          <el-table-column
            label="邀请省代"
            v-if="checkInfo.roleType == 3 && checkInfo.infoType == 2"
            prop="invite_num"
          >
          </el-table-column>

          <el-table-column
            label="邀请CEO"
            v-if="checkInfo.roleType == 3 && checkInfo.infoType == 2"
            prop="invite_ceo_num"
          >
          </el-table-column>

          <el-table-column
            label="是否当季升级"
            v-if="checkInfo.roleType == 3 && checkInfo.infoType == 2"
            prop="real_status"
          >

          </el-table-column>

          <el-table-column
            label="目标金额"
            prop="targetMoney"
          >
          </el-table-column>

        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
export default {
  name: "checkRecord",
  created() {},
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.checkInfo = this.$route.query.good;
    console.info(this.checkInfo);
    if (this.checkInfo == null || this.checkInfo.infoType == null || this.checkInfo.roleType == null)
    {
      this.$router.push("/checkList");
    }
    this.page_num = 1;
    this.handleSearch();
  },
  watch: {
    "checkInfo.infoType"(val) {
      console.info(val);
    },
  },
  data() {
    return {
      tableHeight: null,
      checkInfo: {},
      addLoading: false,
      loading: false,
      filters: {
        keyword: null,
        isCur:null,
        inMonth: new Date(),
        currentYear: "2022",
        quarter: null,
      },
      dialogAddVisible: false,
      page_num: 1,
      keywords: "",
      typeOptions: null,
      proB:0,
      ceoB:0,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
    };
  },
  methods: {
    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/check_record_list_excel?token=" +
        localStorage.getItem("api_token");
      url = url + "&infoType=" + that.checkInfo.infoType;
      url = url + "&roleType=" + that.checkInfo.roleType;
      url = url + "&targetM=" + that.checkInfo.targetMoney;
      if (that.filters.startTime) {
        url = url + "&beginTime=" + that.filters.startTime.getTime();
      }
      if (that.filters.isCur) {
        url = url + "&isCur=" + that.filters.isCur;
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      }
      if (parseInt(that.checkInfo.infoType) == 1) {
        if (that.filters.inMonth != null) {
          var month = parseInt(that.filters.inMonth.getMonth()) + 1;
          if (month < 10) {
            month = "0" + month;
          }
          url =
            url +
            "&inMonth=" +
            that.filters.inMonth.getFullYear() +
            "-" +
            month;
        }
      } else {
        url = url + "&fromMonth=" + that.checkInfo.fromMonth;
        url = url + "&endMonth=" + that.checkInfo.endMonth;
        url = url + "&currentYear=" + that.filters.currentYear;
      }
      if (that.filters.keyword) {
        params.keyword = that.filters.keyword;
        url = url + "&keyword=" + that.filters.keyword;
      }
      top.location.href = url;
    },
    backCheckList() {
      this.$router.push("/checkList");
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    formatterRoleType(row, column) {
      if (row.role_type == -1) {
        return "无";
      } else if (row.role_type == -0.5) {
        return "康减系列VIP会员";
      } else if (row.role_type == -0.4) {
        return "康减系列荣誉会员";
      } else if (row.role_type == -0.3) {
        return "康减系列高级会员";
      } else if (row.role_type == 0) {
        return "VIP门店";
      } else if (row.role_type == 1) {
        return "联盟店";
      } else if (row.role_type == 2) {
        return "市代";
      } else if (row.role_type == 1.05) {
        return "优秀联盟店";
      } else if (row.role_type == 3) {
        return "省代";
      } else if (row.role_type == 4) {
        return "CEO";
      } else if (row.role_type == 1.1) {
        return "康减系列市代";
      } else if (row.role_type == 2.1) {
        return "康减系列省代";
      } else if (row.role_type == 3.1) {
        return "康减系列CEO";
      } else if (row.role_type == 5) {
        return "总经销商";
      } else if (row.role_type == 2.2) {
        return "合伙人";
      } else if (row.role_type == 4.2) {
        return "董事";
      } else if (row.role_type == 5.1) {
        return "区域总监";
      } else if (row.role_type == 5.2) {
        return "城市加盟商";
      } else if (row.role_type == 4.8) {
        word =  "经销商";
      }
    },
    search() {
      let that = this;

      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        infoType: that.checkInfo.infoType,
        roleType: that.checkInfo.roleType,
        token: localStorage.getItem("api_token"),
      };
      if (parseInt(that.checkInfo.infoType) == 1) {
        if (that.filters.inMonth != null) {
          var month = parseInt(that.filters.inMonth.getMonth()) + 1;
          if (month < 10) {
            month = "0" + month;
          }
          params.inMonth = that.filters.inMonth.getFullYear() + "-" + month;
        }
      } else {
        params.fromMonth = that.checkInfo.fromMonth;
        params.endMonth = that.checkInfo.endMonth;
        params.currentYear = that.filters.currentYear;
      }
      if (that.filters.keyword) {
        params.keyword = that.filters.keyword;
      }
      if (that.filters.isCur) {
        params.isCur = that.filters.isCur;
      }
      that.loading = true;
      API.check_record_list(params)
        .then(
          function (result) {
            that.loading = false;
            if (result.key == 1000) {
              that.proB = result.result.data;
              that.ceoB = result.result.token;
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].targetMoney =
                    that.checkInfo.targetMoney;
                }
              }
              that.tableData = result.result.list;
            } else if (result.key == 1001) {
              bus.$emit("goto", "/login");
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    },
  },
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns122 {
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns122 li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/checkRecord.vue